import { WeaveDesignStylesheet } from "../../sharedTypes";

export const checkBoxStyles = (styles: WeaveDesignStylesheet) => {
    return {
        ...styles,
        checkboxWrapper: {
            ...styles.checkboxWrapper,
            marginTop: "auto",
            marginBottom: "auto",
        },
    };
};
